import React from 'react';
import styles from './styles.module.css';

const getRowData = (row, dataIndex) => {
  if (Array.isArray(dataIndex)) {
    return dataIndex.reduce((acc, key) => (acc ? acc[key] : undefined), row);
  } else {
    return row[dataIndex];
  }
}

const Table = ({ columns = [], dataSource = [], isLoading = false }) => {
  if (!columns || !columns.length) {
    return <></>;
  }

  const formatColumns = {};
  columns.forEach(col => {
    formatColumns[col.dataIndex] = col;
  });

  return (
    <div className={styles.wrapperTable}>
      <table className={styles.mainTable}>
        <thead
          className={`${styles.headerTable} ${
            isLoading ? styles.loadingBar : ''
          }`}
        >
          <tr>
            {columns.map(col => {
              return <th key={col.dataIndex}>{col.title}</th>;
            })}
          </tr>
        </thead>

        <tbody className={styles.bodyTable}>
          {dataSource.map(row => {
            return (
              <tr key={row.id}>
                {columns.map((col, index) => {
                  return (
                    <td>
                      {formatColumns[col.dataIndex].render
                        ? formatColumns[col.dataIndex].render(row, index)
                        : getRowData(row, col.dataIndex)}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
